import { type Player, type Match, type Meeting, Sheet, type AuthorizedResult, authorized, unauthorizedAccess, type ShareLink } from '../src/types'
import { push } from 'svelte-spa-router'



export const getMeetings = (matches: Match[]): Meeting[] => {
    let meetings: Meeting[] = []
    let currentMeeting: Meeting|undefined = undefined
    for (let i = 0; i < matches.length; i++) {
        const match = matches[i]
        if (currentMeeting === undefined || match.date != currentMeeting.date) {
            if (currentMeeting) {
                meetings.push(currentMeeting)
            }

            currentMeeting = {
                coupe: match.coupe,
                sheetId: match.sheetId,
                atHome: match.atHome,
                team: match.team,
                date: match.date,
                matches: [],
                totalGain: 0,
            }
        }
        currentMeeting.matches.push(match)
        currentMeeting.totalGain += match.delta
    }
    if (currentMeeting) {
        meetings.push(currentMeeting)
    }
    return meetings
}

export const getMatches = async (
    season: string,
    team: string,
    playerName: string,
    filter:string|undefined=undefined
): Promise<AuthorizedResult<Match[]>|undefined> => {
    let url = `player/${season}/${team}/${playerName}/matches`
    if (filter && filter.length > 0) {
        url += `?filter=${filter}`;
    }
    const response = await fetch(url)
    console.log('response', response)
    if (response.status == 401) {
        return unauthorizedAccess<Match[]>()
    }
    const matches: Match[] = await response.json()
    console.log('data', matches)
    if (!matches || matches.length == 0) {
        const msg: string = `aucun matches pour le joueur ${playerName}`
        console.log(msg)
        return undefined
    }
    return authorized(matches)
}

export const getPlayer = async (
    season: string,
    team: string,
    playerName: string,
    meetingFilter: string|undefined = undefined
): Promise<AuthorizedResult<Player>> => {
    let url = `player/${season}/${team}/${playerName}`;
    if (meetingFilter && meetingFilter.length > 0) {
        url += `?filter=${meetingFilter}`;
    }
    const response = await fetch(url)
    if (response.status == 401) {
        return unauthorizedAccess()
    }
    const player: Player = await response.json()
    if (!player || !player.name || !player.ranking) {
        const msg: string = `aucun joueur ne correspond à ${playerName}`
        console.log(msg)
        return authorized(undefined)
    }
    return authorized(player)
}

export const getPlayerRanking = async (
    season: string,
    team: string,
    playerName: string
): Promise<AuthorizedResult<number>|undefined> => {
    const response = await fetch(
        `player/${season}/${team}/${playerName}/ranking`
    )
    if (response.status == 401) {
        return unauthorizedAccess();
    }
    console.log('response', response)
    const ranking: string = await response.text()
    console.log('data', ranking)
    if (!ranking) {
        const msg: string = `aucun classement ne correspond au joueur ${playerName}`
        console.log(msg)
        return undefined
    }
    return authorized(parseFloat(ranking));
}

export const updateMatch = async (
    match: Match
): Promise<AuthorizedResult<void>> => {
    let url = `/match/${match.id}`
    let query = `double=${match.double}&otherRanking=${match.otherRanking}&date=${match.date}&team=${match.team}&opponent=${match.opponent}&score_me=${match.score.me}&score_other=${match.score.other}`
    console.log(`PUT ${url} ? ${query}`)
    let r = await fetch(url, {
        method: 'PUT',
        body: query,
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
    }
    return authorized(undefined)
}

export const saveSheet = async (
    sheet: Sheet,
    update: boolean
): Promise<AuthorizedResult<void>> => {
    let url = `/sheet`
    let verb = update ? 'PUT' : 'POST'
    console.log(`${verb} ${url}`)
    let r = await fetch(url, {
        method: verb,
        body: JSON.stringify(sheet),
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
    }
    return authorized(undefined);
}

export const getSheet = async (id: string): Promise<AuthorizedResult<Sheet>> => {
    let url = `/sheet/${id}`
    console.log(`GET ${url}`)
    let r = await fetch(url, {
        method: 'GET',
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
        return unauthorizedAccess();
    } else {
        let data = await r.json()
        console.log('raw sheet data for ' + url, data)
        return authorized(data)
    }
}

export const getSheets = async (
    season: string,
    team: string
): Promise<AuthorizedResult<Sheet[]>> => {
    let url = `/sheets/${season}/${team}`
    console.log(`GET ${url}`)
    let r = await fetch(url, {
        method: 'GET',
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
        return authorized([]);
    } else {
        let rawData = await r.text()
        console.log('raw sheet data for ' + url, rawData)
        let sheets = JSON.parse(rawData)
        console.log('sheets' + url, sheets)
        return authorized(sheets)
    }
}

export const uploadSheets = async (sheets: Sheet[]) : Promise<AuthorizedResult<void>> => {
    let url = `/sheets/import`
    let verb = 'POST'
    console.log(`${verb} ${url}`)
    let r = await fetch(url, {
        method: verb,
        body: JSON.stringify(sheets),
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
    }
    return authorized(undefined);
}

export const deleteMeeting = async (id: number): Promise<AuthorizedResult<void>> => {
    let url = `/meeting/${id}`
    console.log(`DELETE ${url}`)
    let r = await fetch(url, {
        method: 'DELETE',
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
    }
    return authorized(undefined);
}

export const getTeamsAndPlayers = async (): Promise<AuthorizedResult<{[team: string]: Player[]}>|undefined> => {
    let url = '/teamsAndPlayers'
    console.log(`GET ${url}`)
    let r = await fetch(url, {
        method: 'GET',
    })
    if (r.status == 401) {
        return unauthorizedAccess()
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
        return undefined
    } else {
        let data: { [team: string]: Player[] } = await r.json()
        console.log('raw sheet data for ' + url, data)
        return authorized(data);
    }
}

export const sendLogin = async (login: string, password: string): Promise<boolean> => {
    let url = `/auth`
    let verb = 'POST'
    const formData = new FormData()
    formData.append('login', login)
    formData.append('password', password)

    console.log(`${verb} ${url}`)
    let r = await fetch(url, {
        method: verb,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: '*/*',
        },
        body: new URLSearchParams({
            login: login,
            password: password,
        }),
    })
    if (r.status == 401) {
        // should not happen !
        return false;
    }
    console.log(r)
    if (r.status != 200) {
        console.log('zut')
        console.log(`une erreur est survenue ${r.status}:${r.statusText}`)
        return false;
    }
    return true;
}

export const openShare = async(link:string): Promise<ShareLink|undefined> => {
    let r = await fetch(`/open/${link}`,
    {method:'GET'});
    if (r.status == 200) {
        const data:ShareLink = await r.json();
        console.log('opening share link ',data);
        return data;
    }

    return undefined;
}


